<template>
  <div class="bg-white px-4 pt-4 rounded-tl-lg rounded-tr-lg">
    <div class="w-full">
      <div class="map-tip"></div>
    </div>
    <a @click="closePlace" class="btn-close">
      <svg 
        class="text-body-lighter"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        xmlns="http://www.w3.org/2000/svg">
          <path d="m14.9467698.00011976 1.0527472 1.05274722-6.947517 6.94613302 6.9479239 6.9478459-1.0527472 1.0527472-6.9471767-6.9475931-6.94725278 6.9477129-1.05274722-1.0527472 6.947-6.9479657-6.94659313-6.94625278 1.05274722-1.05274722 6.94684591 6.947z" transform="translate(.88 .406)"/>
      </svg>
    </a>
    <div class="mt-5">
      <div class="relative">
        <div class="float-right">
          <favorite :place="selectedPlace" />
        </div>
        <h2 class="pr-10 text-lg font-bold">
          {{ selectedPlace.name }}
        </h2>
      </div>
      <div class="mt-2 mb-1">
        <p v-for="benefit in selectedPlace.benefits" v-bind:key="benefit.id" class="inline-block py-1 px-2 mb-1 mr-2 border border-pass rounded text-pass text-sm text-center leading-none">
          {{ benefit.name }}
        </p>
      </div>
    </div>
    <div v-if="showPlaceFull" class="my-2">
      <place-action :place="selectedPlace" />
      <place-full class="mt-4" :place="selectedPlace">
      </place-full>
    </div>
    <div v-else @click="openPlaceDetail" class="pt-2 text-sm text-gray-600">
      <div class="text-center">
        {{$t('tour_place_detail_open')}}
      </div>
      <div class="m-auto text-center w-2">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-link"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlaceFull from './PlaceFull'
import Favorite from '../../molecules/Favorite'
import PlaceAction from './PlaceAction'
import Constants from '../../../constants'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')
import { event } from 'vue-gtag'

export default {
  components: {
    PlaceFull,
    Favorite,
    PlaceAction
  },
  computed: {
    ...mapGetters({
      selectedPlace: 'drawer/getSelectedPlace',
      showPlaceFull: 'drawer/getShowPlaceFull',
      from: 'map/getFrom',
      token: 'user/getToken'
    })
  },
  methods: {
    closePlace: function () {
      this.$store.dispatch('map/updateGooglePlaceMarker', {})
      this.$store.dispatch('drawer/openPlace', { place: {}, full: false })
    },
    openPlaceDetail: function () {
      event("POI詳細表示", {
        poi_id: this.selectedPlace.id,
        poi_name: this.selectedPlace.name
      });
      if(!this.$store.getters['drawer/getIsFull']) {
        this.$store.dispatch('drawer/openPlace', { place: this.selectedPlace, full: true })
      }
    },
    isBenefits: function () {
      if (this.selectedPlace.genreIds.indexOf('benefits') != -1) {
        return true
      } else {
        return false
      }
    },
    mae_maas_url: function () {
      return Constants.LINK_BASE_URL + '/tickets/detail/bus/benefits'
    }
  }
}
</script>
